import { EVENT_DELAY } from '@src/config/constants'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { executeFireAndForgotTask } from '@src/utils/fire-and-forgot-task'
import { getNonce } from '@src/utils/nonce.utils'
import { getSessionId } from '@src/utils/user/session.browser'

import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'
import { TelemetryIntegration } from '../telemetry-events.types'

import { initializeScript } from './provider-utils/initialize-script'

const getUTMStrippedUrl = () => {
  const url = new URL(window.location.href)
  const urlSearchParams = new URLSearchParams(url.searchParams)
  urlSearchParams.forEach((_, key) => {
    if (key.startsWith('utm_')) {
      url.searchParams.delete(key)
    }
  })
  return url.href
}

export const RetentionTracking: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
  },
  initialize: async () => {
    await initializeScript({
      key: 'retention',
      domain: '',
      path: '',
      init: () => {
        const geq = (window.geq = window.geq ?? [])
        if (geq.initialize) return
        if (geq.invoked) {
          if (isBrowser()) {
            console.error('GE snippet included twice.')
          }
          return
        }
        geq.invoked = true
        geq.methods = ['page', 'suppress', 'trackOrder', 'identify', 'addToCart', 'callBack', 'event']
        geq.factory = function (method: unknown) {
          return function (...args: unknown[]) {
            args.unshift(method)
            geq.push(args)
            return geq
          }
        }
        for (const key of geq.methods) {
          if (key) {
            ;(geq as any)[key] = geq.factory(key)
          }
        }
        geq.load = function (key: string) {
          const script = document.createElement('script')
          const nonce = getNonce()
          if (nonce) {
            script.setAttribute('nonce', nonce)
          }
          script.type = 'text/javascript'
          script.async = true
          if (location.href.includes('vge=true')) {
            script.src = 'https://s3-us-west-2.amazonaws.com/jsstore/a/' + key + '/ge.js?v=' + Math.random().toString()
          } else {
            script.src = 'https://s3-us-west-2.amazonaws.com/jsstore/a/' + key + '/ge.js'
          }
          const first = document.getElementsByTagName('script')[0]
          if (first) {
            first.parentNode?.insertBefore(script, first)
          }
        }
        geq.SNIPPET_VERSION = '1.6.1'
        geq.load('9G7H3G0')
      },
    })

    const user_id = getlbUserId()
    const sessionID = getSessionId()
    const userIdentifier = {
      user_id: user_id ? `${user_id}-${sessionID}` : '',
    }
    if (window.geq?.identify) {
      window.geq.identify(userIdentifier)
    }
  },
  events: {
    [TELEMETRY_EVENT_NAMES.PRODUCT_VIEW](properties) {
      const data = {
        Name: properties.productTitle,
        ProductID: properties.productId.toString(),
        ImageURL: properties.variantImageUrl ? 'http:' + properties.variantImageUrl : '',
        URL: getUTMStrippedUrl(),
        Price: properties.price,
        sessionID: getSessionId(),
        lbUserId: getlbUserId(),
      }
      executeFireAndForgotTask(() => {
        if (window.geq?.event) {
          window.geq.event('Viewed Product Reclaim', data)
        }
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.ADD_TO_CART](properties) {
      const data = {
        Name: properties.productTitle,
        ProductID: properties.productId,
        ImageURL: properties.variantImageUrl ? properties.variantImageUrl : '',
        URL: getUTMStrippedUrl(),
        Price: properties.price,
        sessionID: getSessionId(),
        lbUserId: getlbUserId(),
      }
      executeFireAndForgotTask(() => {
        if (window.geq?.addToCart) {
          window.geq.addToCart(data)
        }
      }, EVENT_DELAY)
    },
  },
}
